export enum OrderStatusView {
  New = 'new',
  Requisites = 'requisites',
  CustomerConfirm = 'customer_confirm',
  CustomerConfirmCard = 'customer_confirm_card',
  CustomerConfirmTransfer = 'customer_confirm_transfer',
  TraderConfirm = 'trader_confirm',
  Completed = 'completed',
  Cancelled = 'cancelled',
  Error = 'error',
  Dispute = 'dispute',
}
